import { CategoryBarChart } from '@factorialco/f0-react'

import { SupportedColors } from './types'

type ChartData = {
  color?: SupportedColors
  label: string
  value: number
  formattedValue?: string
}

interface CategoryBarChartWrapperProps {
  groupedChartData: ChartData[]
}

export const CategoryBarChartWrapper = ({ groupedChartData }: CategoryBarChartWrapperProps) => {
  const categoryChartData = groupedChartData.map((x) => ({
    name: x.label + ' ' + x.formattedValue,
    value: x.value,
    color: x.color,
  }))

  return <CategoryBarChart data={categoryChartData} legend />
}
